import { IMentalStatusExamination, IPatientAllergy, IPatientExamination, IPatientSystemiscExamination, IPatientSystemReview } from "@curefit/ehr-common";
import * as React from "react";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppMessages, ConfigConstants, TabNames } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import { EditViewDisplayMode } from "../common/EditViewCard";
import CTA, {CTATheme} from "../common/CallToAction";

export interface PatientPlanTabProps {
    editedBy?: IEditedBy,
    appointmentId?: number,
    patientId: number,
    patientAllergies?: IPatientAllergy[],
    // patientVitals: IPatientVitalResponse[],
    patientPhysio: IPatientExamination[],
    patientSystemicPhysio: IPatientSystemiscExamination[],
    generalExamStatics: IStaticDataValue[],
    // systemicExamStatics: { [key: string]: ISystemicPhysiotaticData },
    saveEditedPhysio: (patientMedicalProfile: IPatientExamination[]) => void,
    saveEditedSystemicPhysio: (patientMedicalProfile: IPatientSystemiscExamination[]) => void,
    savePatientPhysio: (patientId: number, patientMedicalProfile: { Physio: IPatientExamination[], patientSystemicPhysio: IPatientSystemiscExamination[], mentalStatusPhysio?: IMentalStatusExamination[] }, appointmentId: number) => any,
    // pastConsultations: IAppointmentScheduleResponse[],
    nextTab: () => void,
    mentalStatusPhysio: IMentalStatusExamination[],
    // staticMentalStatusPhysio: { [key: string]: IMentalStatusPhysiotaticDataValue },
    saveEditedMentalStatusPhysio: (editedExams: IMentalStatusExamination[]) => void,
    doctorType: string,
    staticReviewSystemsData: IStaticDataValue[],
    saveReviewOfSystemsData: (data: IPatientSystemReview[]) => void,
    reviewOfSystemsData: IPatientSystemReview[],
    uiConfiguration: any[],
    doctorProfile: IDoctorProfile;
    isSelf: boolean,
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    typeFormMapping: any;
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>;
    reviewPhysio: (flag: boolean, clearPdfData: boolean) => void;
    suggestions: {[key: string]: any}

}
export interface PatientPlanTabState {
    error: string,
    isSaving?: boolean,
    errorDetails?: string,
    tabWidgets: any

}


class PatientPlanTab extends React.Component<PatientPlanTabProps, PatientPlanTabState> {
    constructor(props: PatientPlanTabProps) {
        super(props);

        this.state = {
            error: null,
            isSaving: false,
            tabWidgets: this.props.uiConfiguration.filter((widget) => widget.sectionKey === TabNames.PLAN)
        }
    }

    componentWillUnmount() {
        this.saveEditedPhysio();
    }



    getPatientPhysioObject = () => {
        let examinationsObject: any = {};
        examinationsObject[ConfigConstants.NEWCONFIGDATA] = {};
        this.state.tabWidgets.map((widgetData: any) => {
            examinationsObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientPlanTab)[widgetData.subSectionKey].getSaveObject();
        })
        return examinationsObject;
    }

    savePatientUpload = () => {
        AppUtils.getColorConsole(20, null, 'Hello');
        let patientMedicalProfile = this.getPatientPhysioObject();
        this.saveEditedPhysio();
        // this.setState({ isSaving: true, error: null });
        this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType).then(() => {
            // this.props.nextTab();
        }).catch((err: any) => {
            this.setState({
                error: AppMessages.EXAMINATIONS_SAVE_ERROR,
                errorDetails: err.message,
                isSaving: false
            })
        });
        this.props.reviewPhysio(true, true);
    }
    saveEditedPhysio = () => {
        let patientMedicalProfile = { ...this.props.currentMedicalProfile };
        this.state.tabWidgets.map((widgetData: any) => {
            if (patientMedicalProfile[ConfigConstants.NEWCONFIGDATA])
                patientMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientPlanTab)[widgetData.subSectionKey].getSaveObject();
        })
        this.props.saveEditedMedicalProfile(patientMedicalProfile);

    };

    render() {
        const modalHeaders: any = [];
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        return (
            <div className={"plan-upload-tab-container"}>
                {this.state.tabWidgets.map((widgetData: any, index: number) => {
                    let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, false, widgetData.subSectionKey);
                    return <div className="patient-info-subsection concern-section">
                        <GenericEditViewCont appointmentId={this.props.appointmentId}
                            doctorName={this.props.doctorProfile.name}
                            patientId={this.props.patientId}
                            ref={(prescriptionLabTestDOM) => { (this as any | PatientPlanTab)[widgetData.subSectionKey] = prescriptionLabTestDOM }}
                            displayMode={EditViewDisplayMode.EDIT} widgetData={widgetData}
                            tabData={tabData}
                            fetchPatientPastSessions={this.props.fetchPatientPastSessions}
                            modalHeaders={modalHeaders}
                            suggestions={this.props.suggestions} />
                    </div>
                })
                }
                <div className={"save-button collapsible-card"}>
                    <CTA innerText={saveButtonValue} disabled={this.state.isSaving} theme={CTATheme.PRIMARY} onClick={() => {
                        this.savePatientUpload();
                    }} customStyle={{display: "inline"}}/>
                </div>

            </div>
        )
    }
}

export default PatientPlanTab